// L2 · Auditoría del dual-run de lectura (SOMBRA, solo desarrollo). Compara, para cada fila de
// cartelería/hardware que HOY resuelve su vinculación por POSICIÓN (`sii_ref_index` → clave del puente),
// contra la resolución por CLAVE NATURAL (`linea_id_sombra`, vía resolverLinea + lineas_facturacion L1).
//
// El objetivo de L2 es demostrar CERO divergencias entre ambos métodos. No renderiza ni decide nada:
// el loader la llama una vez por carga en dev y emite un único log.info con el resumen.
//
// Divergencia (método): una fila que TIENE vínculo por posición pero cuya resolución por clave natural
// no encuentra línea (`linea_id_sombra == null`) o no corresponde al elemento apuntado. Esperado = 0.
//
// Excepción conocida (dato, no método): una fila HW-OPEX con vínculo → la factura quedó atribuida a la
// línea OPEX. Hoy son los 6 tramos de De La Industria (negocio 11), cuyo folio coincide con la gestión
// gemela; el mislink es de concepto (debería ser gestión), lo resuelve el data-fix de L5, no L2. El
// huérfano del puente (negocio 41, sin `meses_facturacion`) NO es visible acá porque no genera fila.

// Clave del puente `_byRef` para una fila de cartelería/hardware. Espejo de la rama de cartelería de
// `refKeyForOp` en useVFDataLoading.js (10.1: misma convención `${venta_tipo}:${ref_id}:${idx}`).
const refKeyCarteleria = (fila) => {
  if (!fila || fila.negocio_id == null || fila.sii_ref_index == null) return null;
  const tipoCart = fila.type === "HW-CAPEX" ? "negocios_carteleria_hw" : "negocios_carteleria";
  return `${tipoCart}:${fila.negocio_id}:${fila.sii_ref_index}`;
};

const TIPOS_CARTELERIA = new Set(["Gestión", "HW-OPEX", "HW-CAPEX"]);

/**
 * @param {Array<Object>} filas - filas combinadas (se filtran las de cartelería/hardware).
 * @param {Object} siiMap - mapa SII con `_byRef` (clave `${venta_tipo}:${ref_id}:${idx}`).
 * @returns {{filas:number, conVinculo:number, divergencias:Array, excepcionesOpex:Array}}
 */
export const auditarDualRun = (filas, siiMap) => {
  const byRef = (siiMap && siiMap._byRef) || {};
  const divergencias = [];
  const excepcionesOpex = [];
  let conVinculo = 0;
  let filasCart = 0;

  (filas || []).forEach((fila) => {
    if (!TIPOS_CARTELERIA.has(fila.type)) return;
    filasCart += 1;
    const key = refKeyCarteleria(fila);
    const tieneVinculo = key != null && Object.prototype.hasOwnProperty.call(byRef, key);
    if (!tieneVinculo) return;
    conVinculo += 1;

    if (fila.linea_id_sombra == null) {
      divergencias.push({
        id: fila.id,
        negocio_id: fila.negocio_id,
        tipo: fila.type,
        ano: fila.ano,
        mes: fila.mes,
        refKey: key,
        motivo: "vinculo_sin_linea_sombra",
      });
    }

    if (fila.type === "HW-OPEX") {
      excepcionesOpex.push({
        id: fila.id,
        negocio_id: fila.negocio_id,
        ano: fila.ano,
        mes: fila.mes,
        linea_id_sombra: fila.linea_id_sombra,
        refKey: key,
      });
    }
  });

  return { filas: filasCart, conVinculo, divergencias, excepcionesOpex };
};
